import ProductDetails from "../../components/ProductDetails";

const ProductDetailPage = () => {
	return (
		<ProductDetails></ProductDetails>
	)
}

export default ProductDetailPage;